import React, { useEffect, useState } from 'react';

import ClickAwayListener from '@mui/core/ClickAwayListener';
import { ReactComponent as RingIcon } from 'design-system/assets/ring.svg';

import { useNotificationContext } from 'hooks/useNotifications';

import {
  BellButton,
  Container,
  NotificationsBox,
  NotificationsBoxContainer,
  NotificationsContainer,
  NotificationsHeader,
  NotificationsIcon,
  NotificationText,
  Title,
  QuantityContainer,
  QuantityText,
  NotificationsItems,
  NotificationVariant,
} from './styles';
import NotificationItem from './NotificationItem';

const formatBadgeCount = (count: number): string => {
  if (count > 999) return '999';
  return String(count);
};

type NewNotificationsProps = {
  iconColor?: string;
  badgeColor?: string;
  variant?: NotificationVariant;
};

const NewNotifications: React.FC<NewNotificationsProps> = ({
  iconColor = '#3d3d3d',
  badgeColor = '#fc0d1b',
  variant = 'default',
}) => {
  const [showNotificationContainer, setShowNotificationContainer] =
    useState(false);
  const { quantityNotifications, notifications, loadNotifications } =
    useNotificationContext();

  useEffect(() => {
    loadNotifications();
  }, []);

  const hasNotification = quantityNotifications > 0;
  const badgeLabel = formatBadgeCount(quantityNotifications);

  const toggleNotifications = (): void => {
    setShowNotificationContainer((prev) => !prev);
  };

  return (
    <Container>
      <BellButton
        type="button"
        aria-label="Notificações"
        $variant={variant}
        onClick={toggleNotifications}
        style={{ color: iconColor }}
      >
        <RingIcon aria-hidden />
        {hasNotification && (
          <NotificationsContainer $badgeColor={badgeColor} $variant={variant}>
            <NotificationText $variant={variant}>{badgeLabel}</NotificationText>
          </NotificationsContainer>
        )}
      </BellButton>
      {showNotificationContainer && hasNotification && (
        <ClickAwayListener
          onClickAway={() => setShowNotificationContainer(false)}
        >
          <NotificationsBox $variant={variant}>
            <NotificationsIcon />
            <NotificationsBoxContainer>
              <NotificationsHeader>
                <Title>Notificações</Title>
                <QuantityContainer>
                  <QuantityText>{badgeLabel}</QuantityText>
                </QuantityContainer>
              </NotificationsHeader>
              <NotificationsItems>
                {notifications.map((notification, idx) => (
                  <NotificationItem
                    key={notification.id ?? idx}
                    data={notification}
                    lastData={quantityNotifications - 1 === idx}
                  />
                ))}
              </NotificationsItems>
            </NotificationsBoxContainer>
          </NotificationsBox>
        </ClickAwayListener>
      )}
    </Container>
  );
};

export default NewNotifications;
